// extracted by mini-css-extract-plugin
module.exports = {"container":"body__container___1JdKB","with-custom-scrollbar":"body__with-custom-scrollbar___1mHKe"};